import styled from "@emotion/styled";
import { BASE_COLORS } from "../../../../../../../../../../../../emotion-theme";

export const ButtonsContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

export const BuyGetLabel = styled.div`
  display: block;
  width: 64px;
  height: 25px;
  line-height: 25px;
  vertical-align: middle;
  text-align: center;
  position: absolute;
  top: 0;
  right: 0;
  font-weight: 600;
  color: ${BASE_COLORS.black};
  background-color: ${BASE_COLORS.lightGrey};
  text-transform: uppercase;

  .MuiIconButton-root {
    display: block;
    margin: auto;
  }
`;
